import { ICrudGenericFields } from 'models/CrudInterface'

export const companyBranchesFormFields: Array<ICrudGenericFields> = [
	{
		id: 'cod_sucursal',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 5,
		autoComplete: 'new-off',
		disabled: true,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'descrip',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-3',
		height: 'col-sm-12',
		default: null,
		maxChars: 30,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'calle',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-4',
		height: 'col-sm-12',
		default: null,
		maxChars: 40,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'calle_nro',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'piso',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 5,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'dpto',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 5,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'localidad',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-4',
		height: 'col-sm-12',
		default: null,
		maxChars: 40,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'cpos',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'tel',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-4',
		height: 'col-sm-12',
		default: null,
		maxChars: 40,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'orden',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'tipo_fe',
		type: 'combo',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 5,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'digitalBillType',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	}
]
